import { joinPath } from "~/components/inspectorv2/traverseValue/ValuePath";

import { type FieldSet, type QueryBuilderState } from "./QueryBuilderState";
import { type QueryableField } from "./QueryableField";

/**
 * A `Select` node in a query.
 */
export type Select = FieldSet;

export const toggleFieldSelected = (
	s: QueryBuilderState | null,
	field: QueryableField
): QueryBuilderState | null => {
	if (!s) {
		return s;
	}

	const key = joinPath(field.path);
	if (s.get("selectedFields").has(joinPath(field.path))) {
		return s.set("selectedFields", s.get("selectedFields").remove(key));
	}
	return s.set("selectedFields", s.get("selectedFields").set(key, field));
};

export const setFieldSelected = (
	s: QueryBuilderState | null,
	field: QueryableField,
	selected: boolean
): QueryBuilderState | null => {
	if (!s) {
		return s;
	}

	const key = joinPath(field.path);
	if (selected) {
		return s.set("selectedFields", s.get("selectedFields").set(key, field));
	}
	return s.set("selectedFields", s.get("selectedFields").remove(key));
};
